import { useState, useCallback } from 'react';
import type { AgentSwitchNotification } from '../types';

interface UseChatMessageReturn {
  switchNotification: AgentSwitchNotification | null;
  setSwitchNotification: (notification: AgentSwitchNotification | null) => void;
  handleSwitchAgent: (onSwitch: () => void) => void;
  handleSkipSwitch: (onSkip: () => void) => void;
}

export const useChatMessage = (): UseChatMessageReturn => {
  const [switchNotification, setSwitchNotification] = useState<AgentSwitchNotification | null>(null);

  const handleSwitchAgent = useCallback(
    (onSwitch: () => void) => {
      if (switchNotification) {
        onSwitch();
        setSwitchNotification(null);
      }
    },
    [switchNotification]
  );

  const handleSkipSwitch = useCallback(
    (onSkip: () => void) => {
      setSwitchNotification(null);
      onSkip();
    },
    []
  );

  return {
    switchNotification,
    setSwitchNotification,
    handleSwitchAgent,
    handleSkipSwitch,
  };
};

